import React from 'react';
import { Flex, Text, Center } from '@chakra-ui/react';
import { CheckCircleIcon, WarningIcon } from '@chakra-ui/icons';
import { OrderStatusOptions } from 'config/constant';

import moment from 'moment';

const StatusStep = (props) => {
  const step = props.step;

  return (
    <Center>
      {step.status !== 'FAILED' ? (
        <CheckCircleIcon
          w={5}
          h={5}
          color='green.300'
        />
      ) : (
        <WarningIcon
          w={5}
          h={5}
          color='red.400'
        />
      )}
      <Flex
        ml={4}
        direction='column'>
        <Text
          fontSize='md'
          fontWeight='medium'>
          {
            OrderStatusOptions.find((option) => option.value === step.status)
              ?.label
          }
        </Text>
        <Text
          fontSize='sm'
          color='gray.500'>
          Last updated: {moment(step.updated_at).format('DD MMM YY, HH:mm')}
        </Text>
      </Flex>
    </Center>
  );
};

export default StatusStep;
